<template>
    <div class="english-container">
  
      <h1>Démarrage Rapide</h1>
  
      <h2>Android :</h2>
  
      <ol>
        <li>
          Allumez la carte intelligente.
          Attendez que la fenêtre contextuelle apparaisse.
          Si elle ne s’affiche pas,
          suivez les étapes ci-dessous.
        </li>
  
        <li>
          Ouvrez les Paramètres,
          allez dans « Google »
          puis appuyez sur « Tous les services ».
        </li>
  
        <li>
          Dans le menu
          « Appareils connectés et partage »,
          sélectionnez « Appareils ».
        </li>
  
        <li>
          Activez « Rechercher des appareils à proximité ».
        </li>
  
        <li>
          La carte intelligente apparaîtra
          dans la liste des appareils disponibles à proximité.
        </li>
  
        <li>
          Appuyez sur l’appareil
          puis suivez les instructions à l’écran
          pour terminer la connexion.
        </li>
      </ol>
  
      <div class="divider"></div>
  
      <h2>Recherche à proximité</h2>
  
      <p>
        Dans l’application « Google Find Hub »,
        sélectionnez votre carte intelligente
        puis appuyez sur « Lire un son »
        pour localiser votre appareil.
        Une fois trouvé,
        appuyez sur « Arrêter le son ».
      </p>
  
      <h2>Recherche à distance</h2>
  
      <p>
        Dans l’application « Google Find Hub »,
        sélectionnez votre carte intelligente
        puis appuyez sur l’appareil
        pour afficher sa position.
      </p>
  
      <p>
        Pour naviguer jusqu’à l’emplacement,
        appuyez sur « Obtenir l’itinéraire »
        afin d’ouvrir la navigation cartographique.
      </p>
  
      <div class="divider"></div>
  
      <h1>Réinitialisation</h1>
  
      <ol>
        <li>
          Ouvrez l’application « Google Find Hub »,
          sélectionnez votre carte intelligente,
          appuyez sur le bouton Paramètres,
          puis sélectionnez
          « Supprimer de Find Hub »
          et confirmez.
        </li>
  
        <li>
          Lorsque l’appareil est allumé,
          appuyez cinq fois de suite sur le bouton.
          Lors du cinquième appui,
          maintenez le bouton enfoncé
          jusqu’à entendre le signal sonore.
        </li>
      </ol>
  
      <p class="remark">
        Remarque :
        Veuillez allumer la carte intelligente
        et supprimer l’appareil de l’application
        « Google Find Hub »
        avant de procéder à la réinitialisation.
      </p>
  
      <div class="divider"></div>
  
      <h1>Instructions Fast Pair</h1>
  
      <h2>Ajouter une carte intelligente</h2>
  
      <ol>
        <li>
          Assurez-vous que le Bluetooth
          et la connexion réseau de votre téléphone sont activés.
        </li>
  
        <li>
          Appuyez une fois sur le bouton
          pour allumer la carte intelligente
          (un bip sonore sera émis).
        </li>
  
        <li>
          Approchez la carte intelligente
          de votre appareil Android
          et attendez l’apparition de la fenêtre contextuelle.
          <br />
          <strong>Remarque :</strong>
          Si aucune fenêtre n’apparaît,
          redémarrez votre téléphone et réessayez.
        </li>
  
        <li>
          Appuyez sur « Connecter »
          puis acceptez les instructions affichées
          afin de terminer l’appairage.
        </li>
  
        <li>
          Dans l’application « Google Find Hub »,
          sélectionnez « Carte intelligente »
          afin de personnaliser le nom et la catégorie de l’appareil.
        </li>
      </ol>
  
      <div class="divider"></div>
  
      <h1>Activer le mode perdu</h1>
  
      <p>
        Dans l’application « Google Find Hub »,
        sélectionnez votre carte intelligente
        puis appuyez sur « Marquer comme perdu ».
      </p>
  
      <p>
        Ajoutez vos coordonnées
        et vous recevrez une notification
        lorsque le réseau Find Hub
        localisera votre appareil.
      </p>
  
      <h2>Partage de localisation de la carte intelligente</h2>
  
      <p>
        Dans l’application « Google Find Hub »,
        sélectionnez votre carte intelligente
        puis appuyez sur « Partager l’appareil ».
      </p>
  
      <h2>Connexion à un autre téléphone</h2>
  
      <p>
        Une fois le processus de réinitialisation terminé,
        connectez la carte intelligente
        à un autre téléphone Android.
      </p>
  
      <div class="divider"></div>
  
      <h1>Chargement</h1>
  
      <p>
        Utilisez un chargeur sans fil standard
        pour recharger le produit sans fil.
      </p>
  
      <p>
        Le voyant rouge reste allumé pendant la charge
        et s’éteint lorsque l’appareil est complètement chargé.
      </p>
  
    </div>
  </template>
  
  <script>
  export default {
    name: 'AndroidCardFrenchGuide',
  };
  </script>
  
  <style scoped>
  
  .english-container{
    background-color:#ffffff;
    border-radius:8px;
    padding:30px;
    margin:10px auto;
    max-width:1000px;
    box-shadow:0 2px 8px rgba(0,0,0,0.08);
  }
  
  h1{
    font-size:40px;
    margin-top:10px;
    margin-bottom:20px;
    color:#222;
    text-align:left;
  }
  
  h2{
    font-size:24px;
    margin-top:28px;
    margin-bottom:12px;
    color:#333;
    text-align:left;
  }
  
  p{
    font-size:15px;
    line-height:1.8;
    color:#333;
    margin-bottom:14px;
    text-align:left;
  }
  
  ol{
    padding-left:24px;
    margin-bottom:20px;
  }
  
  li{
    font-size:15px;
    line-height:1.8;
    color:#333;
    margin-bottom:10px;
    text-align:left;
  }
  
  strong{
    color:#222;
  }
  
  .remark{
    font-size:14px;
    color:#666;
    background:#f8f8f8;
    padding:12px 14px;
    border-left:4px solid #ff4fa0;
    border-radius:4px;
  }
  
  .divider{
    width:100%;
    height:1px;
    background:#e5e5e5;
    margin:40px 0;
  }
  
  @media (max-width:768px){
  
    .english-container{
      padding:20px;
    }
  
    h1{
      font-size:30px;
    }
  
    h2{
      font-size:20px;
    }
  
    p, li{
      font-size:14px;
    }
  }
  
  </style>